import { AuthedUser } from '../../lib/user'
import { fb } from '../../lib/firebase'
import { xsolla } from '../../lib/xsolla'
import { useMobile } from '../../components/screen/ResponsiveScreen'
import { useLoading } from '../../context/XsollaLoaderContext'

type Props = {
  user: AuthedUser
  onPayStationClose: (event: any, data: any) => void
  onSignOut: () => void
}

export const Profile = ({user, onPayStationClose, onSignOut}: Props) => {
  const isMobile = useMobile();
  const {setLoading} = useLoading();

	const signOut = () => {
		fb.signOut()
    onSignOut()
	}

  const manageSubscriptions = async () => {
      setLoading(true);
      const r = await xsolla.getManageSubscriptionsToken(user, isMobile)
      setLoading(false);
      await xsolla.renderPayStation(r.token)
      xsolla.onPayStationClose(onPayStationClose)
  }

  return (
    <div className="m-4 flex flex-col justify-center content-center">
      <p className="flex text-black-700 dark:text-white font-bold">
        {user.displayName()}
      </p>
      <p className="flex text-gray-700 dark:text-gray-300">
        {user.email()}
      </p>
      <button onClick={manageSubscriptions} className="flex mt-4 text-indigo-700 dark:text-indigo-400 font-bold">
				Manage Subscriptions
			</button>
      <button onClick={signOut} className="flex mt-4 text-indigo-700 dark:text-indigo-400 font-bold">
				Signout
			</button>
    </div>
  )
}
